import { z } from 'zod'

export const WORK_TASK_TRACKER_COMMENT_CONTRACT_VERSION = '1.0.0' as const
export const workTaskTrackerCommentResponseSchema = z.unknown()
export type WorkTaskTrackerCommentResponse = z.infer<typeof workTaskTrackerCommentResponseSchema>
